import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";

const formatEmailLogDate = (value) => {
  if (!value) return "Unknown date";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

export const EmailLogDialog = ({ log, open, onOpenChange }) => {
  const title = log?.subject || log?.template_name || "Untitled email";
  const message = log?.message || "";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[88vh] max-w-3xl overflow-y-auto rounded-2xl p-0" data-testid="email-log-preview-dialog">
        <div className="border-b border-slate-100 bg-slate-50 px-6 py-5">
          <DialogTitle className="text-2xl font-bold text-[#1a1a1a]" style={{ fontFamily: "'Outfit', sans-serif" }}>
            {title}
          </DialogTitle>
          <DialogDescription className="mt-2 text-sm text-slate-500">
            Sent {formatEmailLogDate(log?.created_at)}
          </DialogDescription>
          <div className="mt-4 flex flex-wrap gap-2">
            <Badge className="bg-white text-slate-700 shadow-sm">{log?.success_count || 0}/{log?.recipient_count || 0} sent</Badge>
            <Badge className={log?.status === "sent" ? "bg-[#42D78A]/15 text-[#157347]" : log?.status === "partial" ? "bg-amber-100 text-amber-800" : "bg-red-100 text-red-800"}>
              {log?.status || "unknown"}
            </Badge>
          </div>
        </div>
        <div className="px-6 py-6">
          {message ? (
            <div
              className="prose prose-slate max-w-none rounded-2xl border border-slate-100 bg-white p-5 text-slate-700"
              dangerouslySetInnerHTML={{ __html: message }}
            />
          ) : (
            <p className="rounded-2xl border border-slate-100 bg-slate-50 p-5 text-sm text-slate-500">
              No email preview is available for this older log.
            </p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
